import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { IncidentWorkItemIdSchema, tk } from "@thalamos/vision-common";

import { apiHooks } from "../../api/index.js";
import { MultiPagePdf } from "../../components/index.js";
import { Error as ErrorComponent } from "../Error/Error.js";

export function FormPdf() {
  const params = useParams();
  const { t } = useTranslation();

  const incidentWorkItemId = IncidentWorkItemIdSchema.safeParse(params.id);
  if (!incidentWorkItemId.success) {
    throw new Error("Invalid incident work item id");
  }

  const [{ data: pdfData, error, loading, response }] =
    apiHooks.incidentWorkItem.getPdf(incidentWorkItemId.data);

  if (loading) {
    return <CircularProgress />;
  }

  // An unfinished triage is an ordinary stage of an incident rather than a
  // fault, so having no PDF yet must not be presented as something going
  // wrong.
  if (response?.status === 409) {
    return (
      <Stack
        data-testid="pdf-not-available"
        sx={{ gap: 1, textAlign: "center", alignItems: "center" }}
      >
        <Typography variant="h5" component="div">
          {t(tk("incidentWorkItem.pdfNotAvailableTitle"))}
        </Typography>
        <Typography variant="body1" component="div">
          {t(tk("incidentWorkItem.pdfNotAvailableBody"))}
        </Typography>
      </Stack>
    );
  }

  if (error || pdfData === null) return <ErrorComponent />;

  const render = ({ pdfData }: { pdfData: string | undefined }) => {
    return pdfData ? <MultiPagePdf data={pdfData} /> : <CircularProgress />;
  };
  return render({ pdfData });
}
